import View from './View.js';
import { ASSETS } from '../config.js';

class PreviewView extends View {
  _parentElement = '';

  _generateMarkup() {
    return `
          <li class="product__search--result">
            <a href="product?${this._data.slug}" class="link product__card">
              <div class="product__search--img">
                <img
                  src="${ASSETS}images/product/${this._data.imageCover}"
                  alt="${this._data.tag}"
                />
              </div>
              <div class="product__search--data">
                <h3 class="product__search--brand">
                  ${this._data.brand}
                </h3>
                <h4 class="product__search--tag">${this._data.tag}</h4>
                <div class="product__search--price">
                  <span class="product__search--discounted-price">₹ ${this._data.price}</span>
                  ${
                    this._data.mrp && this._data.mrp - this._data.price > 0
                      ? `<span class="product__search--mrp"> ${this._data.mrp ? `₹ ${this._data.mrp}` : ''}</span>
                  <span class="product__search--discount-percent"
                    >${this._data.mrp ? `(₹${this._data.mrp - this._data.price} OFF)` : ''} </span
                  >`
                      : ''
                  }
                  
                </div>
              </div>
            </a>
          </li>`;
  }
}

export default new PreviewView();
